"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEPOSIT_ALTERNATIVE_FIELD = void 0;
var entities_1 = require("@common/entities");
exports.DEPOSIT_ALTERNATIVE_FIELD = [
    {
        label: 'Deposit Preference',
        type: entities_1.FieldType.Radio,
        customType: entities_1.FieldType.Radio,
        sequence: 1,
        name: 'selectedDepositOption',
        required: false,
        enabled: true,
        options: [
            { label: 'Homebody Deposit', value: entities_1.DepositOptionSelection.Base },
            { label: 'Traditional Deposit', value: entities_1.DepositOptionSelection.Traditional },
        ],
    },
];
